<template>
  <div class="game">
    <div id="head-page" class="globulo parallaxe">
      <parallax>
        <div id="bg1" data-depth="0.3"><img class="" src="@/assets/images/head/sun.png" alt="" title="" /></div>
        <div id="bg2" data-depth="0.2"><img class="" src="@/assets/images/head/colines.png" alt="" title="" /></div>
        <div id="bg3" data-depth="0.1"><img class="" src="@/assets/images/head/montagnes.png" alt="" title="" /></div>
        <div id="bg4" data-depth="0.2"><img class="" src="@/assets/images/head/sapins.png" alt="" title="" /></div>
        <div id="bg5" data-depth="0.5"><img class="" src="@/assets/images/head/nuages.png" alt="" title="" /></div>
        <div id="front-1" data-depth="0.2"></div>
      </parallax>
    </div>

    <div class="grid-container content-page fiche-jeu">
      <div class="grid-x grid-margin-x">
        <div class="small-12 cell">
          <title-page attrpage="Mini jeux" baseline="Le jeu sera bientôt disponible">Transfusion Sanguine</title-page>

          <p>On va te faire une transfusion sanguine bientôt et tu te demandes ce que c’est ?</p>
          <p>C’est un soin qui a pour but de donner à ton sang ce dont il a besoin pour que tu sois en forme. Dans le sang il y a différents éléments : globules rouges, globules blanc et plaquettes qui ont tous un rôle à jouer dans ta santé. S’il n’y en a plus assez, le médecin prescrit une transfusion sanguine et c’est l’infirmière qui la réalise.</p>
          <p>Pour mieux comprendre comment cela va se dérouler, je t’invite à lire la fiche illustrée sur ce sujet.</p>
          <p>Bien sûr, tu peux aussi demander aux personnes qui te soignent et à tes parents de t’expliquer la transfusion sanguine en leur montrant ce document.</p>
          <p>Courage à toi.</p>


          <div class="notif-infos">Le jeu est en cours de développement, tu pourras jouer prochainement !</div>
          </div>

          <div class="grid-x grid-margin-x">
            <div class="small-12 cell">
              <h3>Les ressources complémentaires</h3>
            </div>

            <div class="small-12 medium-6 large-4 cell">
              <item-fiche lien="https://www.sparadrap.org/boutique/produit/fiche-la-transfusion-sanguine"  titlebox="Fiche La transfusion sanguine" type-item="fiche">Une fiche pour expliquer aux enfants les différents éléments du sang, à quoi sert une transfusion sanguine, comment elle se déroule et d’où proviennent les produits sanguins utilisés.</item-fiche>
            </div>


          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import TitlePage from '@/components/TitlePage'
  import Bouton from '@/components/Bouton.vue'
  import ItemFiche from '@/components/ItemFiche'
  export default {
    props: ['gameId'],
    components: { TitlePage, Bouton, ItemFiche },
    mounted() {
      this.$store.dispatch('playGame', this.gameId)
    }
  }
</script>
